import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../../hoc/AxiosSetting/axios'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment';
import * as BiIcons from 'react-icons/bi';
import * as AiIcons from 'react-icons/ai';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';



export default class ViewAuditee extends Component {

    constructor(props) {
        super(props)
        this.state = {
            //   orgCode : props.match.params.orgcode,
            //   auditplanurl: "",

            reportOfauditee: {
                orgCode: props.match.params.orgcode,
                contractreviewurl: "",

            },
            editStatus: false,
            showMessage: false,

            data: {},

        }
    }

    componentDidMount() {
        axios.get(APIURL + '/api/auditee/get/auditeedetails/' + this.state.reportOfauditee.orgCode)

            .then(res => {
                console.log("data ", res.data.response)
                if (res.data.errorCode === 0) {
                    this.setState({ data: res.data.response })
                   

                }
            })
            .catch(e => {
                console.log("Something went Wrong", e)
            })


    }
    handleRoute = () => {
        window.location.href = "/"+localStorage.getItem("role")+'/auditeedetails/' + this.state.reportOfauditee.orgCode;
    }
    //   handleRoute = (id) => {
    //     window.location.href="/admin/auditeedetails/"+id}
    render() {
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                             
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ paddingLeft: "50px" }}>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="row">
                                                <label htmlFor="staticEmail" className="col-sm-2">Organization Name</label>
                                                    <div className="col-sm-10">
                                                        <p>{this.state.data.orgName}</p>
                                                    </div>

                                                </div>

                                                <div className="row mt-4">

                                                    <div className="card-body table-responsive">
                                                        <table className="table table-bordered " >
                                                            <thead className="table-primary">
                                                                <tr>

                                                                    <th scope="col" className="text-center" style={{ "width": "120px" }}>Sr. No.</th>
                                                                    <th scope="col" className="text-center" style={{ "width": "120px" }}>Name</th>
                                                                    <th scope="col" className="text-center" style={{ "width": "120px" }}>Designation</th>
                                                                    <th scope="col" className="text-center" style={{ "width": "120px" }}>Departmant</th>
                                                                    <th scope="col" className="text-center" style={{ "width": "120px" }}>Email </th>
                                                                    <th scope="col" className="text-center" style={{ "width": "180px" }}>Mobile Number</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody >

                                                                {this.state.data && this.state.data.auditeeDetails && this.state.data.auditeeDetails.length && this.state.data.auditeeDetails.length > 0 ?
                                                                    this.state.data.auditeeDetails.map((item, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td className="text-center">{index + 1}</td>
                                                                                <td>{item.auditeeName}</td>
                                                                                <td>{item.auditeeDesignation}</td>
                                                                                <td>{item.auditeeDepartment}</td>
                                                                                <td>{item.auditeeEmail}</td>
                                                                                <td>{item.auditeeMobileNum}</td>

                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    <>No Data Added </>

                                                                }

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                { 
                    localStorage.getItem("userRole")==="Management" || localStorage.getItem("userRole")==="Accounts" ?
                    ""
                    :
                <div className="card-footer">
                    <div className="row">
                        <div className="col-sm-10"></div>
                        <div className="col-sm-2">

                            <button type="submit" className="btn btn-primary float-right" onClick={() => this.handleRoute()}>Edit</button>

                        </div>

                    </div>
                </div>

                }
            </div>



        )
    }
}
